import { render, staticRenderFns } from "./RazorpayPaymentBtn.vue?vue&type=template&id=1ec08371&scoped=true"
import script from "./RazorpayPaymentBtn.vue?vue&type=script&lang=js"
export * from "./RazorpayPaymentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec08371",
  null
  
)

export default component.exports